import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  DatePickerComponent,
  DropBox,
  FormHeader,
  ImageComponent,
  InputBox,
  PDFPreviewer,
  PDFUploader,
  Uploader,
} from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { Store } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import Scrollbars from "react-custom-scrollbars-2";
import TagsSelectBox from "../../templates/tagsSelectBox";
import { createNewGazette, updateJobs } from "./service/jobs.service";
import { deleteImage } from "../../../components/imageComponent/service/upload.service";
import { openCreateTagModal } from "../../Tags/redux/actions";
import { clearedSelectJobs } from "../../Jobs/redux/actions";
import { convertToRaw, ContentState, EditorState } from "draft-js";

const CreateNewGazette = (props) => {
  const dispatch = useDispatch();
  const [language, setLanguage] = useState("si");
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);

  const selectJobs = useSelector((state) => state.jobsReducer.selectJobs);

  const { datePickData } = useSelector(({ datePicker }) => datePicker);

  const [formData, setFormData] = useState({
    gazetteDate: {
      key: "gazetteDate",
      label: "Gazette Date",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "YYYY-MM-DD",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [applicationType, setApplicationType] = useState("");
  const [selectTagList, setSelectTagList] = useState([]);
  const [selectedTagList, setSelectedTagList] = useState([]);
  // const [gazetteDate, setgazetteDate] = useState(null);

  const [image, setImage] = useState({
    si_url: [],
    en_url: [],
    ta_url: [],
  });

  // const [procumentImage, setProcumentImage] = useState({
  //   si_url: [],
  //   en_url: [],
  //   ta_url: [],
  // });

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      setFormData(updateForm);
    }
  };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  useEffect(() => {
    if (datePickData?.date) {
      const updatedForm = {
        ...formData,
      };
      updateForm.gazetteDate.value = datePickData.date;
      setFormData(updatedForm);
    }
  }, [datePickData]);

  // const onChangeJobApplication = (imageData, type) => {
  //   try {
  //     if (type === "si") {
  //       setJobApplication((prev) => ({
  //         ...prev,
  //         si_url: imageData?.file_url,
  //       }));
  //     }
  //     if (type === "en") {
  //       setJobApplication((prev) => ({
  //         ...prev,
  //         en_url: imageData?.file_url,
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error uploading image:", error);
  //   }
  //   // setJobApplication(imageData.file_url);
  //   // console.log("job application", imageData.file_url);
  // };

  const onChangeImage = (imageData, type) => {
    try {
      if (type === "si") {
        console.log("si", image.si_url);
        setImage((prev) => ({
          ...prev,
          si_url: [...prev.si_url, imageData],
        }));
      }
      if (type === "en") {
        setImage((prev) => ({
          ...prev,
          en_url: [...prev.en_url, imageData],
        }));
      }
      if (type === "ta") {
        setImage((prev) => ({
          ...prev,
          ta_url: [...prev.ta_url, imageData],
        }));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  // const onChangeProcumetImage = (imageData, type) => {
  //   try {
  //     if (type === "si") {
  //       console.log("si", image.si_url);
  //       setProcumentImage((prev) => ({
  //         ...prev,
  //         si_url: [...prev.si_url, imageData],
  //       }));
  //     }
  //     if (type === "en") {
  //       setProcumentImage((prev) => ({
  //         ...prev,
  //         en_url: [...prev.en_url, imageData],
  //       }));
  //     }
  //     if (type === "ta") {
  //       setProcumentImage((prev) => ({
  //         ...prev,
  //         ta_url: [...prev.ta_url, imageData],
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error uploading procument:", error);
  //   }
  // };

  const tagsSelect = (tags) => {
    setSelectTagList(tags);
  };

  const onClickRemoveImage = async (key, type, imageType) => {
    console.log(key);
    try {
      const res = await deleteImage(key);
      console.log("remove image", res);
      if (imageType === "image") {
        if (type === "si") {
          setImage((prev) => ({
            ...prev,
            si_url: prev.si_url?.filter((item) => item.file_name !== key) || [],
          }));
        } else if (type === "en") {
          setImage((prev) => ({
            ...prev,
            en_url: prev.en_url?.filter((item) => item.file_name !== key) || [],
          }));
        } else {
          setImage((prev) => ({
            ...prev,
            ta_url: prev.ta_url?.filter((item) => item.file_name !== key) || [],
          }));
        }
      }
    } catch (error) {
      console.log("Error in deleting image", error);
    }
  };

  // const onChangeDate = (date, dateString) => {
  //   console.log(date, dateString);
  //   setgazetteDate(dateString);
  // };

  useEffect(() => {
    if (selectJobs?.job_id) {
      console.log({ selectJobs });
      const updatedForm = {
        ...formData,
      };

      // updateForm["gazetteDate"].value = moment(selectJobs?.closing_date).format(
      //   "YYYY-MM-DD"
      // );
      updateForm["gazetteDate"].value = selectJobs?.closing_date;

      if (!Array.isArray(selectJobs?.job_details?.si_url)) {
        let fileName = selectJobs?.job_details?.si_url?.replace(
          "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
          ""
        );
        setImage({
          si_url: [
            { file_name: fileName, file_url: selectJobs.job_details?.si_url },
          ],
        });
      } else if (!Array.isArray(selectJobs?.job_details?.en_url)) {
        let fileName = selectJobs?.job_details?.en_url?.replace(
          "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
          ""
        );
        setImage({
          en_url: [
            { file_name: fileName, file_url: selectJobs?.job_details?.en_url },
          ],
        });
      } else if (!Array.isArray(selectJobs?.job_details?.ta_url)) {
        let fileName = selectJobs?.job_details?.ta_url?.replace(
          "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
          ""
        );
        setImage({
          ta_url: [
            { file_name: fileName, file_url: selectJobs.job_details?.ta_url },
          ],
        });
      } else {
        setImage(selectJobs.job_details);
      }

      // if (!Array.isArray(selectJobs?.procurement_details?.si_url)) {
      //   let fileName = selectJobs?.procurement_details?.si_url?.replace(
      //     "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
      //     ""
      //   );
      //   setProcumentImage({
      //     si_url: [
      //       {
      //         file_name: fileName,
      //         file_url: selectJobs.procurement_details?.si_url,
      //       },
      //     ],
      //   });
      // } else if (!Array.isArray(selectJobs?.procurement_details?.en_url)) {
      //   let fileName = selectJobs?.procurement_details?.en_url?.replace(
      //     "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
      //     ""
      //   );
      //   setProcumentImage({
      //     en_url: [
      //       {
      //         file_name: fileName,
      //         file_url: selectJobs?.procurement_details?.en_url,
      //       },
      //     ],
      //   });
      // } else if (!Array.isArray(selectJobs?.procurement_details?.ta_url)) {
      //   let fileName = selectJobs?.procurement_details?.ta_url?.replace(
      //     "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
      //     ""
      //   );
      //   setProcumentImage({
      //     ta_url: [
      //       {
      //         file_name: fileName,
      //         file_url: selectJobs.procurement_details?.ta_url,
      //       },
      //     ],
      //   });
      // } else {
      //   setProcumentImage(selectJobs.procurement_details);
      // }

      setSelectedTagList(selectJobs?.tags || []);

      setFormData(updatedForm);
    } else {
      for (let key in updateForm) {
        console.log(updateForm[key]);
        updateForm[key].value = "";
        updateForm[key].isValid = false;
        updateForm[key].touched = false;
      }
      setFormData(updateForm);
      clearAll();
    }
  }, [selectJobs]);

  const categorySelect = (value) => {
    console.log({ value });
    const updateForm = { ...formData };
    updateForm["organization"].value = value;
    setFormData(updateForm);
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      // console.log(updateForm[key]);
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }

    setImage({
      si_url: [],
      en_url: [],
      ta_url: [],
    });

    // setProcumentImage({
    //   si_url: [],
    //   en_url: [],
    //   ta_url: [],
    // });

    setSelectTagList([]);
    setSelectedTagList([]);

    setFormData(updateForm);
    setEditorState(EditorState.createEmpty());
    props.refresh(true);
    // setIsButtonDisabled(true);
    // setIsLoading(false);
  };

  const onClickSave = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const updateForm = {
      ...formData,
    };
    try {
      const res = await createNewGazette({
        gazette_date: updateForm.gazetteDate.value,
        tags: selectTagList,
        job_details: image,
        // procurement_details: procumentImage,
      });
      console.log("res", res);
      setIsLoading(false);

      if (res?.data) {
        Store.addNotification({
          title: "Success",
          message: "Gazette created successfully",
          type: "success",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        clearAll();
      }
    } catch (error) {
      console.error("Error creating gazette:", error);
      Store.addNotification({
        title: "Error",
        message: "Failed to create gazette",
        type: "danger",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);
    try {
      if (selectJobs?.job_id) {
        const updateForm = { ...formData };

        const body = {
          closing_date: updateForm.gazetteDate.value,
          tags: selectTagList,
          job_details: image,
          // procurement_details: procumentImage,
        };
        const response = await updateJobs(body, selectJobs?.job_id);
        console.log("jobs", response);
        setIsLoading(false);

        if (response?.data) {
          console.log("Jobs Category Updated Successfully");
          // dispatch(updateJobCategory(response?.data));

          Store.addNotification({
            title: "Success!",
            message: "Jobs Updated Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        }
      }
    } catch (error) {
      console.log("Error updating Jobs");
      Store.addNotification({
        title: "Error!",
        message: "Jobs Update Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      setIsButtonDisabled(false);
      clearAll();
    }
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-create-gazette-wrapper">
        <FormHeader
          data={{
            formHeader: "Create New Gazette",
            size: "md-md",
          }}
        />
        <Scrollbars
          onScroll={handleOnScroll}
          renderView={(props) => (
            <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
          )}
          style={{ height: viewPointHeight - 260 }}
        >
          <div
            style={{
              paddingBottom: "32px",
              paddingRight: "16px",
            }}
          >
            <>
              <div className="gazette-date">
                {/* <label>Closing Date</label> */}
                {/* <Space direction="vertical">
                  <DatePicker
                    size="large"
                    style={{ width: "100%" }}
                    allowClear={true}
                    placement="bottomLeft"
                    onChange={onChangeDate}
                  />
                </Space> */}

                <DatePickerComponent data={updateForm.gazetteDate} />
              </div>

              <div
                className="d-flex justify-content-end align-items-end mt-2"
                style={{
                  marginBottom: "-25px",
                  position: "relative",
                  zIndex: "90",
                }}
              >
                <Button
                  data={{
                    btnName: "Create New",
                    buttonType: "secondary s-border",
                    buttonSize: "xs x",
                    // isLoading: isLoading,
                  }}
                  onClick={(e) => {
                    dispatch(openCreateTagModal());
                  }}
                />
              </div>

              <TagsSelectBox
                onChangeTag={tagsSelect}
                tagList={selectedTagList || []}
                data={{
                  language: language,
                }}
              />

              <div style={{ marginBottom: "10px" }}>
                <div className={"hne-cjw-uploader-lable"}>Job Details</div>

                <div className={"d-flex flex-column"}>
                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "si")}
                      />
                      <span className={"hne-cjw-lable"}>Sinhala</span>
                    </div>

                    {image?.si_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: image?.si_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          console.log("img", imageData);
                          setImage((prev) => ({
                            ...prev,
                            si_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>

                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      {/* {image?.en_url && (
                        <>
                          <ImageComponent
                            data={{
                              size: "md mt-3",
                              imgUrl: image?.en_url,
                              isPdf: image?.en_url?.endsWith(".pdf"),
                            }}
                            onClickRemove={() => {
                              if (selectJobs?.job_id) {
                                setImage((prev) => ({
                                  ...prev,
                                  en_url: "",
                                }));
                              } else {
                                onClickRemoveImage(
                                  image?.en_url?.file_name,
                                  "en",
                                  "image"
                                );
                              }
                            }}
                          />
                        </>
                      )}

                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: true,
                          // uploaderLable: "Banner image (1000x 720)",
                          iconName: "upload-cloud",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "en")}
                      /> */}

                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "en")}
                      />
                      <span className={"hne-cjw-lable"}>English</span>
                    </div>

                    {image?.en_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: image?.en_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          setImage((prev) => ({
                            ...prev,
                            en_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>

                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) => onChangeImage(imageData, "ta")}
                      />
                      <span className={"hne-cjw-lable"}>Tamil</span>
                    </div>

                    {image?.ta_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: image?.ta_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          setImage((prev) => ({
                            ...prev,
                            ta_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* <div style={{ marginBottom: "10px" }}>
                <div className={"hne-cjw-uploader-lable"}>Procument Notice</div>

                <div className={"d-flex flex-column"}>
                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                        }}
                        onChange={(imageData) =>
                          onChangeProcumetImage(imageData, "si")
                        }
                      />
                      <span className={"hne-cjw-lable"}>Sinhala</span>
                    </div>

                    {procumentImage?.si_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: procumentImage?.si_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          console.log("img", imageData);
                          setProcumentImage((prev) => ({
                            ...prev,
                            si_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>

                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      
                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) =>
                          onChangeProcumetImage(imageData, "en")
                        }
                      />
                      <span className={"hne-cjw-lable"}>English</span>
                    </div>

                    {procumentImage?.en_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: procumentImage?.en_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          setProcumentImage((prev) => ({
                            ...prev,
                            en_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>

                  <div className={"d-flex flex-column align-items-center"}>
                    <div>
                      <PDFUploader
                        data={{
                          disabled: false,
                          isLable: false,
                          iconName: "upload-cloud",
                          // key: "pdfUploader",
                        }}
                        onChange={(imageData) =>
                          onChangeProcumetImage(imageData, "ta")
                        }
                      />
                      <span className={"hne-cjw-lable"}>Tamil</span>
                    </div>

                    {procumentImage?.ta_url?.length > 0 && (
                      <PDFPreviewer
                        data={{
                          attachments: procumentImage?.ta_url,
                          size: "lg mt-3",
                        }}
                        setPDFList={(imageData) => {
                          setProcumentImage((prev) => ({
                            ...prev,
                            ta_url: imageData || [],
                          }));
                        }}
                      />
                    )}
                  </div>
                </div>
              </div> */}
            </>
          </div>
        </Scrollbars>

        <div
          className="d-flex flex-row justify-content-between"
          style={{ marginBottom: "15px" }}
        >
          {selectJobs?.job_id && (
            <Button
              data={{
                btnName: "Clear",
                buttonType: "secondary mr-2",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                dispatch(clearedSelectJobs());
                clearAll();
              }}
            />
          )}

          <Button
            data={{
              btnName: selectJobs?.job_id ? "UPDATE" : "DONE",
              // buttonType:
              //   updateForm.jobTitleEN.value === "" ||
              //   updateForm.jobTitleSI.value === ""
              //     ? "primary disabled"
              //     : "primary",
              buttonType: "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              // disable:
              //   updateForm.jobTitleEN.value === "" ||
              //   updateForm.jobTitleSI.value === ""
              //     ? true
              //     : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectJobs?.job_id) {
                await onClickUpdate(e);
              } else {
                await onClickSave(e);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(CreateNewGazette);
